import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Row, Col, Table } from 'react-bootstrap';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { CME_ADMIN_API, CME_KHOA_DAO_TAO_API } from '../../../../utils/apiUrl';
import { Get, Post } from '../../../../utils/httpProvider';
import { messageToast, status200 } from '../../../../utils/define';
import { Formik, FieldArray } from 'formik';
import * as Yup from 'yup';

const CMEEventAddEditModal = ({ isOpen, handleClose, data, refetch }) => {
    // Lấy danh sách tiểu mục để map vai trò
    const { data: catData } = useQuery(
        ['cmeAllCategories'],
        () => Get(CME_ADMIN_API.GET_CATEGORIES),
        { enabled: isOpen }
    );

    const cats = catData?.$values || catData || [];
    const upsertFunc = useMutation((payload) => Post(CME_KHOA_DAO_TAO_API.UPSERT, null, payload));

    const initialValues = {
        tenKhoaDaoTao: data?.tenKhoaDaoTao || '',
        maKhoaDaoTao: data?.maKhoaDaoTao || '',
        tuNgay: data?.tuNgay ? data.tuNgay.substring(0, 10) : '',
        denNgay: data?.denNgay ? data.denNgay.substring(0, 10) : '',
        diaDiem: data?.diaDiem || '',
        soTiet: data?.soTiet || 0,
        ghiChu: data?.ghiChu || '',
        roles: (data?.cmeKhoaDaoTaoVaiTros?.$values || data?.cmeKhoaDaoTaoVaiTros || []).map(r => {
            const foundCat = cats.find(c => 
                (c.cmeTieuMucs?.$values || c.cmeTieuMucs || []).some(tm => tm.id === r.tieuMucId)
            );
            return {
                tenVaiTro: r.tenVaiTro,
                tieuMucId: r.tieuMucId,
                catId: foundCat?.id || ''
            };
        })
    };

    if (initialValues.roles.length === 0) {
        initialValues.roles = [{ tenVaiTro: 'Học viên', tieuMucId: '', catId: '' }];
    }

    const validationSchema = Yup.object().shape({
        tenKhoaDaoTao: Yup.string().required('Bắt buộc nhập tên khóa đào tạo'),
        soTiet: Yup.number().min(0.1, 'Số tiết phải lớn hơn 0').required('Bắt buộc nhập số tiết'),
        roles: Yup.array().of(
            Yup.object().shape({
                tenVaiTro: Yup.string().required('Tên vai trò không được để trống'),
                tieuMucId: Yup.string().required('Phải chọn tiểu mục tương ứng')
            })
        )
    });

    const handleSubmit = (values) => {
        const payload = {
            ...data,
            ...values,
            cmeKhoaDaoTaoVaiTros: values.roles
        };

        upsertFunc.mutate(payload, {
            onSuccess: (res) => {
                if (res.status === status200 || res.id) {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    refetch();
                    handleClose();
                }
            }
        });
    };

    return (
        <Modal show={isOpen} onHide={handleClose} size="lg" backdrop="static" style={{ zIndex: '9999' }}>
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>{data ? 'Chỉnh sửa khóa đào tạo' : 'Thêm mới khóa đào tạo'}</Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                    <Form onSubmit={handleSubmit}>
                        <Modal.Body>
                            <Row>
                                <Col md={8}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Tên khóa đào tạo / Hoạt động <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            name="tenKhoaDaoTao"
                                            value={values.tenKhoaDaoTao}
                                            onChange={handleChange}
                                            isInvalid={touched.tenKhoaDaoTao && !!errors.tenKhoaDaoTao}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.tenKhoaDaoTao}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Mã khóa (nếu có)</Form.Label>
                                        <Form.Control
                                            name="maKhoaDaoTao"
                                            value={values.maKhoaDaoTao}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Từ ngày</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="tuNgay"
                                            value={values.tuNgay}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Đến ngày</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="denNgay"
                                            value={values.denNgay}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Tổng số tiết <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="soTiet"
                                            value={values.soTiet}
                                            onChange={handleChange}
                                            isInvalid={touched.soTiet && !!errors.soTiet}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.soTiet}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Địa điểm tổ chức</Form.Label>
                                        <Form.Control
                                            name="diaDiem"
                                            value={values.diaDiem}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <hr />
                            <h6 className="text-primary font-weight-bold mb-3">
                                <i className="fas fa-users-cog mr-2"></i>Cấu hình Vai trò & Cách tính điểm
                            </h6>

                            <FieldArray name="roles">
                                {({ push, remove }) => (
                                    <Table bordered size="sm">
                                        <thead className="bg-light">
                                            <tr>
                                                <th style={{ width: '25%' }}>Tên vai trò (Dùng để Import)</th>
                                                <th style={{ width: '30%' }}>Danh mục chính</th>
                                                <th>Quy định CME (Tiểu mục)</th>
                                                <th style={{ width: '40px' }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {values.roles.map((role, index) => {
                                                const selectedCat = cats.find(c => c.id === role.catId);
                                                const subItems = selectedCat ? (selectedCat.cmeTieuMucs?.$values || selectedCat.cmeTieuMucs || []) : [];
                                                
                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            <Form.Control
                                                                size="sm"
                                                                name={`roles.${index}.tenVaiTro`}
                                                                value={role.tenVaiTro}
                                                                onChange={handleChange}
                                                                placeholder="VD: Học viên"
                                                                isInvalid={touched.roles?.[index]?.tenVaiTro && !!errors.roles?.[index]?.tenVaiTro}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                as="select"
                                                                size="sm"
                                                                name={`roles.${index}.catId`}
                                                                value={role.catId}
                                                                onChange={(e) => {
                                                                    setFieldValue(`roles.${index}.catId`, e.target.value);
                                                                    setFieldValue(`roles.${index}.tieuMucId`, ''); // Reset tiểu mục khi đổi danh mục
                                                                }}
                                                            >
                                                                <option value="">-- Chọn danh mục --</option>
                                                                {cats.map(c => <option key={c.id} value={c.id}>{c.tenDanhMuc}</option>)}
                                                            </Form.Control>
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                as="select"
                                                                size="sm"
                                                                name={`roles.${index}.tieuMucId`}
                                                                value={role.tieuMucId}
                                                                onChange={handleChange}
                                                                isDisabled={!role.catId}
                                                                isInvalid={touched.roles?.[index]?.tieuMucId && !!errors.roles?.[index]?.tieuMucId}
                                                            >
                                                                <option value="">-- Chọn tiểu mục --</option>
                                                                {subItems.map(tm => (
                                                                    <option key={tm.id} value={tm.id}>
                                                                        {tm.tenTieuMuc} ({tm.vaiTro} - {tm.dinhMucGio}h/{tm.donViTinh})
                                                                    </option>
                                                                ))}
                                                            </Form.Control>
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            <Button variant="link" className="text-danger p-0" onClick={() => remove(index)}>
                                                                <i className="fas fa-times"></i>
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                            <tr>
                                                <td colSpan={4}>
                                                    <Button variant="link" size="sm" onClick={() => push({ tenVaiTro: '', tieuMucId: '', catId: '' })}>
                                                        <i className="fas fa-plus mr-1"></i>Thêm vai trò khác
                                                    </Button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                )}
                            </FieldArray>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>Đóng</Button>
                            <Button variant="primary" type="submit" disabled={upsertFunc.isLoading}>
                                {upsertFunc.isLoading ? 'Đang lưu...' : 'Lưu thông tin'}
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default CMEEventAddEditModal;
